import React, { useEffect, useState } from "react";
import { convertFileToBase64 } from "../../../../components/utils/utils";
import { Col, Form, Row } from "antd";
import Inputs from "../../../../biblio/Inputs/Inputs";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import {
  DeleteOutlined,
  PlusCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import Selects from "../../../../biblio/Selects/Selects";

interface FamilyHousingInfoProps {
  form: any;
  housingTypes: any;
  housingStates: any;
}

const FamilyHousingInfo = ({
  form,
  housingTypes,
  housingStates,
}: FamilyHousingInfoProps) => {
  const [blocks, setBlocks] = useState<
    Array<{
      housing_state_id: number;
      housing_type_id: number;
      amount: number;
      contract_attachment_ids: { filename: string; data: string }[];
      fileList: any[];
    }>
  >([
    {
      housing_state_id: 0,
      housing_type_id: 0,
      amount: 0,
      contract_attachment_ids: [],
      fileList: [],
    },
  ]);

  const addBlock = () => {
    const newBlock = {
      housing_state_id: 0,
      housing_type_id: 0,
      amount: 0,
      contract_attachment_ids: [],
      fileList: [],
    };
    setBlocks([...blocks, newBlock]);
  };

  const handleFileChange = async (fileList: any[], index: number) => {
    const file = fileList[0]?.originFileObj;

    if (file) {
      try {
        const base64 = (await convertFileToBase64(file)) as string;
        const imageData = {
          filename: file.name,
          data: base64,
        };

        const updatedBlocks = [...blocks];
        updatedBlocks[index].contract_attachment_ids = [imageData];
        updatedBlocks[index].fileList = fileList;
        setBlocks(updatedBlocks);
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    } else {
      const updatedBlocks = [...blocks];
      updatedBlocks[index].contract_attachment_ids = [];
      updatedBlocks[index].fileList = fileList;
      setBlocks(updatedBlocks);
    }
  };

  useEffect(() => {
    const materialStateData = blocks.map((block, index) => ({
      housing_state_id: block.housing_state_id,
      housing_type_id: block.housing_type_id,
      amount: block.amount,
      contract_attachment_ids: block.contract_attachment_ids,
    }));

    form.setFieldValue("housing_type_ids", materialStateData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocks]);

  const onChange = (
    value: any,
    key:
      | "housing_state_id"
      | "housing_type_id"
      | "amount"
      | "contract_attachment_ids",
    index: number
  ) => {
    const l__bloks = [...blocks];
    if (key === "housing_state_id" || key === "housing_type_id") {
      l__bloks[index][key] = value.value;
    } else {
      l__bloks[index][key] = value;
    }

    setBlocks(l__bloks);
  };
  const removeItem = (index: number) => {
    const updatedBlocks = [...blocks];
    updatedBlocks.splice(index, 1);
    const json: any = {};

    updatedBlocks.forEach((el: any, index: number) => {
      json["housing_state_id" + index] =
        el.housing_state_id !== 0 ? el.housing_state_id : "";
      json["housing_type_id" + index] =
        el.housing_type_id !== 0 ? el.housing_type_id : "";
      json["amount" + index] = el.amount !== 0 ? el.amount : "";
      json["contract_attachment_ids" + index] = el.contract_attachment_ids;
    });
    form.resetFields();
    form.setFieldsValue(json);
    setBlocks(updatedBlocks);
  };
  return (
    <>
      <div className="takaful--title-tabs-sub">
        <span>ممتلكات الأسرة</span>
      </div>
      {blocks.map((block, index) => (
        <Row gutter={16} key={index}>
          <Col xxl={5} xl={5} lg={5} md={5} sm={20} xs={20}>
            <Form.Item
              name={`housing_type_id${index}`}
              label="النوع"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{
                className: "takaful--label-style",
              }}
            >
              <Selects
                options={housingTypes?.data}
                onChange={(e) => onChange(e, "housing_type_id", index)}
              />
            </Form.Item>
          </Col>
          <Col xxl={5} xl={5} lg={5} md={5} sm={20} xs={20}>
            <Form.Item
              name={`housing_state_id${index}`}
              label="الحالة"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects
                options={housingStates?.data}
                onChange={(e) => onChange(e, "housing_state_id", index)}
              />
            </Form.Item>
          </Col>
          <Col xxl={5} xl={5} lg={5} md={5} sm={20} xs={20}>
            <Form.Item
              name={`amount${index}`}
              label="المبلغ المستفاد"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs
                type="tel"
                onChange={(e) => onChange(e.target.value, "amount", index)}
              />
            </Form.Item>
          </Col>
          <Col xxl={5} xl={5} lg={5} md={5} sm={20} xs={20}>
            <Form.Item
              name={`contract_attachment_ids${index}`}
              label="مرفقات"
              labelCol={{ className: "takaful--label-style" }}
            >
              <UploadInput
                accept="*"
                text="تحميل مرفقات"
                icon={<UploadOutlined />}
                multiple={false}
                onChange={(fileList) => handleFileChange(fileList, index)}
                maxCount={1}
                list={block.fileList}
              />
            </Form.Item>
          </Col>

          <Col xxl={1} xl={1} lg={4} md={4} sm={4} xs={4}>
            {blocks.length > 1 && (
              <Form.Item
                name={`remove${index}`}
                label=" "
                labelCol={{ className: "takaful--label-style" }}
              >
                <PrimaryButton
                  title=""
                  icon={<DeleteOutlined />}
                  onClick={() => removeItem(index)}
                />
              </Form.Item>
            )}
          </Col>
        </Row>
      ))}

      <Col
        className="takaful--button-material"
        xxl={2}
        xl={2}
        lg={4}
        md={4}
        sm={24}
        xs={24}
      >
        <PrimaryButton
          title="إضافة بند"
          icon={<PlusCircleOutlined />}
          onClick={() => addBlock()}
          className="takaful--primary-button-info"
        />
      </Col>
    </>
  );
};

export default FamilyHousingInfo;
